<div class="main-container">
    <div class="label-bar">
     <label i18n="@@spmsUserReg" class="textColour" style="font-size: 18px;
    font-weight: 500; margin-right: 0.5rem;">Activity Configuration</label>
    <app-common-button
      *ngIf="defaultActivities.length > 0"
          label="Import"
          title="Import Default Activities"
          [buttonId]="1111"
          icon="fas fa-download"
          width="100%"
          padding="0rem 1rem"
          fontSize=".85rem"
          height="25px"
          (clicked)="importDefaultActivities()"
          
          > 
      </app-common-button>
     <span class="example-spacer"></span>
       <app-common-button
          icon="fas fa-download"
          title="Download"
          [buttonId]="1111"
          [variant]="'cancel'"
          width="100%"
          padding="0rem 1rem"
          fontSize=".85rem"
          height="25px"
          (clicked)="onDownload()"
          style="margin-right:1%"
          > 
      </app-common-button>
             <app-common-button
            
          title="Refresh"
          icon="fas fa-sync-alt"
          [buttonId]="1111"
          [variant]="'cancel'"
          width="100%"
          padding="0rem 1rem"
          fontSize=".85rem"
          height="25px"
          (clicked)="onRefresh()"
          style="margin-right:1%"
          >
      </app-common-button>
       <app-common-button
            label="Create"
          title="Create"
          icon="fas fa-plus-circle"
          [buttonId]="1111"
          width="100%"
          padding="0rem 1rem"
          fontSize=".85rem"
          height="25px"
          (clicked)="onCreate()"
          style="margin-right:1%"
          >
      </app-common-button>
  </div>
  <div style="width: 100%;margin-bottom: 5%;">
    <ag-grid-angular
      style="margin-top: 2%;height: 55vh;"
      class="ag-theme-balham"
      [rowData]="rowData"
      [components]="components"
      [columnDefs]="columnDefs"
      [defaultColDef]="defaultColDef"
      [rowSelection]="'multiple'"
      [suppressRowClickSelection]="true"
      [animateRows]="true"
      [paginationPageSize]="10"
      (gridReady)="onGridReady($event)"
      (selectionChanged)="onSelectionChanged($event)"
      [rowHeight]="35"
      [headerHeight]="35"
      [enableBrowserTooltips]="true"
      [floatingFiltersHeight]="45"
      [pagination]="true">
    </ag-grid-angular>
     <!-- <div class="custom-pagination">
  <span class="range-text">
    {{ startRow }} to {{ endRow }} of {{ totalRows }}
  </span> -->

  <!-- <button (click)="goToFirst()" [disabled]="currentPage === 1">
     
  </button> -->
  <!-- <em class="fas fa-angle-double-left waves-effect waves-light" (click)="goToFirst()"></em>
  <em class="fas fa-angle-left waves-effect waves-light"
                                    (click)="goToPrevious()"></em> -->
  <!-- <button (click)="goToPrevious()" [disabled]="currentPage === 1">‹</button> -->

  <!-- <span class="page-text">
    Page {{ currentPage }} of {{ totalPages }}
  </span>
<em class="fas fa-angle-right waves-effect waves-light" (click)="goToNext()"></em>
<em class="fas fa-angle-double-right waves-effect waves-light" (click)="goToLast()"></em> -->
  <!-- <button (click)="goToNext()" [disabled]="currentPage === totalPages">›</button>
  <button (click)="goToLast()" [disabled]="currentPage === totalPages">»</button> -->
<!-- </div> -->
  </div>

   <div class="bulk-action-bar" *ngIf="getSelectedCount() > 0">
  <div class="bulk-action-content">

    <!-- Close -->
    <button
      class="icon-btn"
      aria-label="Close selection bar"
      (click)="clearSelection()">
      ✖
    </button>

    <!-- Count -->
    <span class="selection-count">
      <i class="pi pi-check-circle"></i>
      {{ getSelectedCount() }} Items Selected
    </span>

    <div class="divider"></div>

    <!-- Actions -->
    <button class="action-btn" (click)="clearSelection()">
      <i class="pi pi-times"></i> Clear
    </button>

    <button *ngIf="this.selectedConfigRows.length == 1" class="action-btn" (click)="onEditSelected()">
      <i class="pi pi-pencil"></i> Edit Selected
    </button>

    <button class="action-btn" (click)="onDeleteSelected()">
      <i class="pi pi-trash"></i> Delete Selected
    </button>

  </div>
</div>
    </div>